export default __webpack_public_path__ + "e8d0d2591aad1ffb5640ec893a9aa10f.svg";